// extracted by mini-css-extract-plugin
export var badge = "_hs-2";
export var detailsPanel = "_hs-0";
export var resultRow = "_hs-1";